/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BusinessInstallationStatusResponse
 */
export interface BusinessInstallationStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof BusinessInstallationStatusResponse
     */
    status: BusinessInstallationStatusResponseStatusEnum;
}


/**
 * @export
 */
export const BusinessInstallationStatusResponseStatusEnum = {
    pending: 'pending',
    installing: 'installing',
    ready: 'ready',
    failed: 'failed'
} as const;
export type BusinessInstallationStatusResponseStatusEnum = typeof BusinessInstallationStatusResponseStatusEnum[keyof typeof BusinessInstallationStatusResponseStatusEnum];


/**
 * Check if a given object implements the BusinessInstallationStatusResponse interface.
 */
export function instanceOfBusinessInstallationStatusResponse(value: object): value is BusinessInstallationStatusResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function BusinessInstallationStatusResponseFromJSON(json: any): BusinessInstallationStatusResponse {
    return BusinessInstallationStatusResponseFromJSONTyped(json, false);
}

export function BusinessInstallationStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessInstallationStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
    };
}

export function BusinessInstallationStatusResponseToJSON(json: any): BusinessInstallationStatusResponse {
    return BusinessInstallationStatusResponseToJSONTyped(json, false);
}

export function BusinessInstallationStatusResponseToJSONTyped(value?: BusinessInstallationStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
    };
}

